const AUTH_QUERY_KEYS = ['token', 'callback', 'redirect', 'afterLogin', 'returnTo', 'lang']

function queryValue(value) {
  const first = Array.isArray(value) ? value[0] : value
  return first == null ? '' : String(first).trim()
}

/** Save the complete protected URL, including route params and payment/session query. */
export function loginRedirectQuery(to, afterLogin = to.name) {
  return {
    ...to.query,
    returnTo: to.fullPath,
    afterLogin,
    lang: to.params.lang || 'fa',
  }
}

export function loginTokenQuery(route, token) {
  return {
    ...route.query,
    token,
    callback: queryValue(route.query.callback) || 'dashboard',
    lang: route.params.lang || queryValue(route.query.lang) || 'fa',
  }
}

function knownReturnTarget(target, router) {
  try {
    const resolved = router.resolve(target).route
    if (!resolved || !resolved.matched.length) return null
    if (resolved.name === 'login' || resolved.name === 'LoginWithToken') return null
    if (resolved.matched.some((record) => record.meta && record.meta.guest)) return null
    return target
  } catch (e) {
    return null
  }
}

/** Restore a local application route; keep auth tokens out of legacy return queries. */
export function loginReturnTarget(route, router) {
  const query = route.query || {}
  const returnTo = queryValue(query.returnTo)
  const isLocalPath = returnTo.startsWith('/') && !returnTo.startsWith('//')
  const invalidCharacters = Array.from(returnTo).some((char) => char === '\\' || char.charCodeAt(0) <= 32)
  if (isLocalPath && !invalidCharacters) {
    const target = knownReturnTarget(returnTo, router)
    if (target) return target
  }

  const name = queryValue(query.afterLogin)
  if (!name) return null
  const nextQuery = {...query}
  AUTH_QUERY_KEYS.forEach((key) => { delete nextQuery[key] })
  if (nextQuery.reffer_id != null) {
    const referral = queryValue(nextQuery.reffer_id)
    if (referral) nextQuery.reffer_id = referral
    else delete nextQuery.reffer_id
  }
  return knownReturnTarget({
    name,
    params: {lang: queryValue(query.lang) || route.params.lang || 'fa'},
    query: nextQuery,
  }, router)
}
